import { createSlice } from '@reduxjs/toolkit'

const initialState = { dataTablePageSize: 50 }

const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState: initialState,
  reducers: {
    setDataTablePageSize: (state, action) => {
      if (action.payload) {
        state.dataTablePageSize = parseInt(action.payload)
      }
    },
  },
})

export const { setDataTablePageSize } = userSettingsSlice.actions

export default userSettingsSlice.reducer

export const selectDataTablePageSize = (state) => state.userSettings.dataTablePageSize
